<template>
  <div style="padding-bottom: 70px;">
   <el-form disabled>
<!--     <el-row style="width: 100%;padding-top: 10px;">
       <el-col :span="8">
         <el-form-item label="维修成本" label-width="140px">
           <el-input-number v-model="repairPlan.service_price"/>
         </el-form-item>
       </el-col>
       <el-col :span="8">
         <el-form-item label="物料成本" label-width="110px">
           <el-input-number v-model="repairPlan.material_total_price"/>
         </el-form-item>
       </el-col>
       <el-col :span="8">
         <el-form-item label="总计成本" label-width="90px">
           <el-input-number v-model="repairPlan.total_price"/>
         </el-form-item>
       </el-col>
     </el-row>-->
     <StationTroubleList ref="stationTroubleList" :parentData="parentData"/>
<!--     <div v-if="repairPlan.trouble_list" >
       <div v-for="trouble in repairPlan.trouble_list" :key="trouble.trouble_id"
            style="border: solid 1px #d7dade;margin: 0 20px 20px 20px;">
         <FrameForm ref="frameForm" component-param="bu_batching" :parentData="trouble" v-if="trouble"/>
       </div>
     </div>
     <div v-else style="border: solid 1px #d7dade;margin: 0 20px 20px 20px;">
       <FrameForm ref="frameForm" component-param="bu_batching" :parentData="parentData"/>
     </div>-->
   </el-form>
    <el-row class="oqcSubmit-row">
      <el-button @click="submit" :loading="loading">配料完成</el-button>
      <KfMessage ref="submitMsg"></KfMessage>
    </el-row>
  </div>
</template>

<script>

import {ElMessageBox} from "element-plus";
import StationTroubleList from "@/views/applications/station/StationTroubleList";

export default {
  name: "StationBatching",
  components: {StationTroubleList},
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      repairPlan: {},
    }
  },
  computed: {
  },
  created() {
    this.getRepairPlanList ()
  },
  mounted() {
  },
  methods: {

    //获取物品维修方案
    async getRepairPlanList() {
      this.repairPlan = await this.$http('buItemService.getRepairPlanList', {item_id: this.parentData.id,})
    },

    clearMessage() {
      this.$refs.submitMsg.clear()
    },
    reset() {
      this.formData = {}
      this.buItemAppendix = []
      // this.$refs.submitMsg.clear()
    },

    submit() {
      ElMessageBox.confirm(
          '确定提交当前工站作业结果吗？',
          '提示',
          {
            confirmButtonText: '确认',
            type: 'warning',
          }
      ).then(() => {
        this.submitResult()
      })
    },

    submitResult() {
      this.$refs.submitMsg.clear()

      this.loading = true;
      let params = this.repairPlan
      params.id = this.parentData.id
      params.product_sn = this.parentData.product_sn
      params.station_id = 'batching'
      params.result = 'finish'
      this.$http('buItemService.submitBatchIngResult', params, false).then(data => {
        this.loading = false;
        this.$refs.submitMsg.showSuccess(data);
        this.reset()
        this.$fn.reset()
        this.$fn.closeWindow()
      }, errMsg => {
        this.loading = false;
        this.$refs.submitMsg.showError(errMsg);
      })
    }
  }
}
</script>

<style scoped lang="less">

.trouble-form{
  padding: 10px 0 0 0;
  width: 700px;
}

.trouble-item {
  border: 1px solid #ddd;
  margin-bottom: 10px;

  .title {
    background-color: #ddd;
    padding: 5px 0 5px 10px;
    font-weight: bold;
  }
}

.btn-row {
  padding: 5px 0;
}

.oqcSubmit-row {
  margin: 10px 0;
  padding-top: 0px;
  padding-left: 150px;
  //border-top: 1px solid #ddd;
}
</style>